import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";

const ImageUploadCustom = ({
  avatar = false,
  changeBtnColor = "primary",
  setFieldValue,
  name,
  value,
  setError,
  errors = {},
  label,
  defaultImg = defaultImage,
}) => {
  const { t } = useTranslation("common");
  const [imagePreviewUrl, setImagePreviewUrl] = useState(
    value ? value : avatar ? defaultAvatar : defaultImg
  );
  // useEffect(() => {
  //   setImagePreviewUrl(value ? value : avatar ? defaultAvatar : defaultImg);
  // }, [value, avatar, defaultImg]);
  useEffect(() => {
    if (value) {
      if (typeof value === "string") {
        setImagePreviewUrl(value); // Use the URL if value is a string
      } else if (value instanceof File) {
        setImagePreviewUrl(URL.createObjectURL(value)); // Create preview URL for file
      }
    } else {
      setImagePreviewUrl(avatar ? defaultAvatar : defaultImg);
    }
  }, [value, avatar, defaultImg]);

  const fileInput = useRef(null);

  const handleImageChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (!file) return;
    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!validTypes.includes(file.type)) {
      setError((prevErrors) => ({
        ...prevErrors,
        [name]: t("imageUpload.invalidFormat"),
      }));
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      setError((prevErrors) => ({
        ...prevErrors,
        [name]: t("imageUpload.tooLarge"),
      }));
      return;
    }
    setError((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setImagePreviewUrl(URL.createObjectURL(file));
    setFieldValue(name, file);
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  const handleRemove = () => {
    setImagePreviewUrl(avatar ? defaultAvatar : defaultImage);
    fileInput.current.value = "";
    setFieldValue(name, "");
    setError((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  return (
    <div className="fileinput">
      {label && (
        <Label
          className="d-block w-100 text-left mb-2 text-capitalize"
          htmlFor={name}
        >
          {label}
        </Label>
      )}
      <input
        type="file"
        onChange={handleImageChange}
        ref={fileInput}
        accept="image/jpeg, image/jpg, image/png"
        hidden
      />
      <div
        onClick={handleClick}
        className={"thumbnailCustom" + (avatar ? " img-circle" : "")}
      >
        <img src={imagePreviewUrl} alt={t("imageUpload.preview")} />
      </div>
      <div>
        {value && (
          <span>
            <i
              color={changeBtnColor}
              onClick={handleClick}
              className={`tim-icons icon-pencil mr-3 text-warning pointer `}
            ></i>
            {avatar ? <br /> : null}
            <i
              onClick={handleRemove}
              className={`tim-icons icon-trash-simple text-danger pointer `}
            ></i>
          </span>
        )}
      </div>
      {errors[name] && <p className="text-danger">{errors[name]}</p>}
    </div>
  );
};

ImageUploadCustom.propTypes = {
  avatar: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  setFieldValue: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  errors: PropTypes.object,
  removeBtnClasses: PropTypes.string,
  removeBtnColor: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
    "link",
  ]),
  addBtnClasses: PropTypes.string,
  addBtnColor: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
    "link",
  ]),
  changeBtnClasses: PropTypes.string,
  changeBtnColor: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
    "link",
  ]),
};

export default ImageUploadCustom;
